import { useState } from 'react';
import { BenefitsBadgeVariant } from '../../../shared/components';
import { Household } from '../../../types/global';
import HouseholdMarkerCard from '../components/HouseholdMarkerCard';
import { getHouseholdKey } from '../utils';
import HouseholdCardContainer from './householdCardContainer';

const benefitsVariant = BenefitsBadgeVariant.OnBenefits;

export type HouseholdMarkerContainerProps = {
  households: readonly Household[],
  setClickedMarker: (marker: null) => void,
}

export default function HouseholdMarkerContainer({
  households, setClickedMarker,
}: Readonly<HouseholdMarkerContainerProps>) {
  const [selectedHousehold, setSelectedHousehold] = useState<Household | null>(null);
  const [returnFocusTo, setReturnFocusTo] = useState<Household | null>(null);
  const closeMarker = () => setClickedMarker(null);
  const selectHousehold = (household: Household) => {
    setSelectedHousehold(household);
    setReturnFocusTo(household);
  };

  if (households.length === 1) {
    // One household
    const [household] = households;
    return (
      <HouseholdCardContainer
        key={getHouseholdKey(household)}
        household={household}
        benefitsVariant={benefitsVariant}
        onClose={closeMarker}
      />
    );
  }

  if (selectedHousehold) {
    // The picked household's card in place of the list. Closing it goes back to the list
    return (
      <HouseholdCardContainer
        key={getHouseholdKey(selectedHousehold)}
        household={selectedHousehold}
        benefitsVariant={benefitsVariant}
        onClose={() => setSelectedHousehold(null)}
      />
    );
  }

  return (
    // The list of households to pick from
    <HouseholdMarkerCard
      households={households}
      setClickedMarker={setClickedMarker}
      onSelectHousehold={selectHousehold}
      returnFocusTo={returnFocusTo}
    />
  );
}
